// extracted by css-extract-rspack-plugin
export default {"cls1":"RelatedPapers-cls1_hK0","cls2":"RelatedPapers-cls2_iaM RelatedPapers-cls1_hK0"};